export const ResultComment = ({ props }) => ([
  { text: 'Kommentiert', value: '\'!=null\'' },
  { text: 'Nicht kommentiert', value: '::null' },
])
